import React from "react";

export const Error404 = () => {
    return <span>Página não encontrada</span>;
};
